import { render, staticRenderFns } from "./BusinessFinancialStatement.vue?vue&type=template&id=86e4247a"
import script from "./BusinessFinancialStatement.vue?vue&type=script&lang=js"
export * from "./BusinessFinancialStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports